import React, { createContext, useState } from 'react'

export const ApplicationContext = createContext({
  data: {},
  updateApplicationContext: () => {},
})

export const ApplicationContextProvider = ({ children }) => {
  const [state, setState] = useState({})

  const updateApplicationData = (updatedState) => {
    setState((prevState) => ({ ...prevState, ...updatedState }))
  }

  const value = {
    data: state,
    updateApplicationContext: updateApplicationData,
  }

  return (
    <ApplicationContext.Provider value={value}>
      {children}
    </ApplicationContext.Provider>
  )
}
